import mixpanel from "mixpanel-browser/dist/mixpanel-core.cjs.js" // core build: no session replay

// Thin wrapper so components can call track() without caring whether Mixpanel
// is configured. The token comes from a <meta> tag that the layout only renders
// when config.x.mixpanel_token is set, so everything here no-ops in dev.
let ready = false

export function initAnalytics() {
  if (ready) return true
  const token = document.querySelector('meta[name="mixpanel-token"]')?.content
  if (!token) return false
  mixpanel.init(token, {
    track_pageview: false, // Turbo swaps pages without reloads; see trackPageview()
    persistence: "localStorage",
  })
  ready = true
  return true
}

export function track(event, props = {}) {
  if (initAnalytics()) mixpanel.track(event, props)
}

let lastUrl = null
// The workspace opts out (<meta name="mixpanel-autopageview" content="false">):
// it sends only explicit, non-PII events (doc 07 §9).
function pageviewsDisabled() {
  return document.querySelector('meta[name="mixpanel-autopageview"]')?.content === "false"
}

export function trackPageview() {
  if (pageviewsDisabled() || !initAnalytics() || location.href === lastUrl) return
  lastUrl = location.href
  mixpanel.track_pageview()
}
